import { render, staticRenderFns } from "./UnitStockCard.vue?vue&type=template&id=da97fe16&scoped=true"
import script from "./UnitStockCard.vue?vue&type=script&lang=js"
export * from "./UnitStockCard.vue?vue&type=script&lang=js"
import style0 from "./UnitStockCard.vue?vue&type=style&index=0&id=da97fe16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da97fe16",
  null
  
)

export default component.exports